$(function () {
    $(".copyValueAsSame").each(function () {
        $(this).on('change', function () {
            let inputIDs = $(this).data('copy-value-as-same-for-id').split(';')
            if ($(this).is(':checked')) {
                inputIDs.forEach(function (inputID) {
                    let input = $("#" + inputID);
                    input.prop('readonly', true)
                    let baseInput = $("#"+input.data('copy-value-as-same-from-id'));
                    input.val(baseInput.val())
                    baseInput.on('keyup change',function (){
                        input.val(baseInput.val())
                    })
                })
            } else {
                inputIDs.forEach(function (inputID) {
                    let input = $("#" + inputID);
                    input.prop('readonly', false)
                    let baseInput = $("#"+input.data('copy-value-as-same-from-id'));
                    baseInput.off('keyup')
                })
            }
        })

        $(this).trigger('change');
    })
})
